module.exports = __webpack_public_path__ + "static/img/C4D0031.1d1cc02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0031.jpg
// module id = dUU6
// module chunks = 0